import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { AdminGuard } from '@core/guards/admin-guard/admin-guard.guard';
import { LogoutComponent } from '@shared/components/logout/logout.component';
import { OpsGuard } from '@core/guards/ops-guard/ops-guard.guard';
import { NotFoundComponent } from 'src/app/not-found/not-found.component';

const normalGuards = [OktaAuthGuard];
const opsGuards = [OktaAuthGuard, OpsGuard];

export const routes: Routes = [
  {
    path: '',
    title: 'GLASS',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('@modules/home/home.module').then((m) => m.HomeModule),
        canActivate: normalGuards,
      },
      {
        path: 'watch',
        title: 'GLASSwatch',
        loadChildren: () => import('@modules/watch/watch.routes').then((m) => m.watchRoutes),
        canActivate: normalGuards,
      },
      {
        path: 'watch/bolt/tab-view',
        title: 'GLASSwatch - BOLT TabView',
        loadComponent: () => import('@modules/boltview/pages/boltview.component').then((m) => m.BoltViewComponent),
        canActivate: normalGuards,
      },
      {
        path: 'watch/bolt/multiview',
        title: 'GLASSwatch - BOLT Multiview',
        loadComponent: () => import('@modules/bolt-multiview/pages/bolt-multiview/bolt-multiview.component').then((m) => m.BoltMultiviewComponent),
        canActivate: normalGuards,
      },
      {
        path: 'watch/boltview',
        redirectTo: 'watch/bolt/tab-view',
        pathMatch: 'full',
      },
      {
        path: 'watch/multiview',
        title: 'GLASSwatch - Multiview',
        loadComponent: () => import('@modules/multiview/pages/multiview/multiview.component').then((m) => m.MultiviewComponent),
        canActivate: normalGuards,
      },
      {
        path: 'watch/stats',
        title: 'GLASSwatch - Stats',
        loadComponent: () => import('@modules/stats/pages/stats-page/stats-page.component').then((m) => m.StatsPageComponent),
        canActivate: normalGuards,
      },
      {
        path: 'faq',
        title: 'GLASS - FAQ',
        loadChildren: () => import('@modules/faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'tools',
        title: 'GLASStools',
        loadChildren: () => import('@modules/tools/tools.module').then((m) => m.ToolsModule),
      },
      {
        path: 'cmr',
        title: 'GLASScmr',
        loadChildren: () => import('@modules/cmr/cmr.routes').then((m) => m.CMR_ROUTES),
        canActivate: normalGuards,
      },
    ],
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'admin',
    title: 'GLASSadmin',
    component: ContentLayoutComponent,
    loadChildren: () => import('./modules/admin/admin.routes').then((m) => m.adminRoutes),
    canActivate: [AdminGuard],
    canMatch: [AdminGuard],
  },
  {
    path: 'ops/v2',
    title: 'GLASSops',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/ops_v2/ops-v2.routes').then((m) => m.OPS_V2_ROUTES),
        canActivate: opsGuards,
        canMatch: [OpsGuard],
      },
    ],
  },
  {
    path: '**',
    component: ContentLayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
];

// AppRoutingModule is no longer needed with standalone components
// Routes are exported directly and used with provideRouter in main.ts
